import axios from './api';

import { formatSurveyQuestions, transformSurveyQuestions } from './utilities/helpers';

/**
 * read a survey's questions
 * @param {Object} options
 * @param {Number} options.id
 * @param {Boolean} [options.isMultiLevelDisqualifyEnabled]
 * @param {Object} [options.params]
 * @param {AbortSignal} [options.signal]
 * @return {Promise}
 */
export const readSurveyQuestions = async ({
  id,
  isMultiLevelDisqualifyEnabled = true,
  params,
  signal,
}) => {
  return axios({
    method: 'get',
    params: {
      ...params,
    },
    signal,
    url: `/instantsurvey/instantsurvey/${id}/questions`,
  }).then(({ data }) => transformSurveyQuestions(data, { isMultiLevelDisqualifyEnabled }));
};

/**
 * update a survey's questions
 * @param {Object} options
 * @param {Object} [options.carryForwardLogic]
 * @param {Number} options.id
 * @param {Boolean} [options.isMultiLevelDisqualifyEnabled]
 * @param {Object} [options.questionLogic]
 * @param {Question[]} options.questions
 * @param {AbortSignal} [options.signal]
 * @return {Promise}
 */
export const updateSurveyQuestions = async ({
  carryForwardLogic,
  id,
  isMultiLevelDisqualifyEnabled = true,
  questionLogic,
  questions,
  signal,
}) => {
  return axios({
    data: formatSurveyQuestions({ carryForwardLogic, questionLogic, questions }),
    method: 'put',
    signal,
    url: `/instantsurvey/instantsurvey/${id}/questions`,
  }).then(({ data }) => transformSurveyQuestions(data, { isMultiLevelDisqualifyEnabled }));
};
